import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function CompressorTable({ data, onEdit }) {
  const columns = [
    {
      title: "Compressure Title",
      dataIndex: "title",
      key: "title",
      align: "center",
    },
    {
      title: "Compressure Make",
      dataIndex: "compressor_make",
      key: "compressor_make",
      align: "center",
    },
    {
      title: "Compressure Model",
      dataIndex: "compressor_make",
      key: "compressor_make",
      align: "center",
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
